export default __webpack_public_path__ + "static/media/post7.c39e9f5f.jpg";